export { COVERT_EN_US } from "./couvert-en-us";
export { COVERT_ES_MX } from "./couvert-es-mx";
export { COVERT_FR_FR } from "./couvert-fr-fr";
export { COVERT_PT_BR } from "./couvert-pt-br";
export type { CouvertTranslations } from "./couvert-pt-br";
